"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeaderContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledHeaderContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')}};
  justify-content: ${({ right }) => (right ? 'flex-end' : 'flex-start')}};
  width: ${({ half }) => (half ? '50%' : '100%')}};
`;
